import { EMAIL } from '../../data/siteData';
import { PageHero } from '../../components/Layout';

const sections = [
  {
    h: 'Information we collect',
    p: 'When you submit an enquiry, we may collect your name, email address, phone number, company details, and message. We use this information to respond to your request and discuss relevant services with you.',
  },
  {
    h: 'How we use information',
    p: 'Personal information is used for communication, service planning, customer support, and legitimate business administration. We do not sell personal information to third parties under any circumstances.',
  },
  {
    h: 'Sharing and storage',
    p: 'Information may be processed by trusted service providers such as email platforms, hosting providers, analytics services, or form handling tools. We take reasonable steps to keep information secure and only retain it for as long as necessary.',
  },
  {
    h: 'Legal basis for processing',
    p: 'We process personal data on the basis of contractual necessity, legitimate interests for business administration, and consent where explicitly provided.',
  },
  {
    h: 'Your rights',
    p: `You have the right to access, correct, or request deletion of your personal information. To exercise these rights, contact us at ${EMAIL}.`,
  },
  {
    h: 'Policy updates',
    p: 'This policy may be updated as our website and services develop. The most current version will always be published on this page.',
  },
];

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        text="This policy explains how ClearDesk Support Ltd collects, uses, and protects your personal information."
        backgroundImage="../../abouthero.webp"
      />
      <div className="section-pad">
        <div className="policy-content">
          {sections.map((section) => (
            <div key={section.h} style={{ marginBottom: 24 }}>
              <h2>{section.h}</h2>
              <p>{section.p}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
